/**
 * [resp-img]
 * responsive images via data-resp-img-* attributes
 */
window.coma = window.coma || {};

window.coma.nav = (function($, undefined) {

    // PRIVATE FUNCTIONS
    var _private = {    

        init: function() {


            $(document).on('mediaqueries-changed', function (e) {
                // the new mediaquery (xs, sm, md, lg) is stored in e.message
                _private.removePageOverflowOnDesktop(e.message);
                _private.addMobileHeaderNavEvent(e.message);
                _private.addMainContentExpansion(e.message);

            });

            // add event to mobile (sx device) menu toggle button
            this.addMobileNavToggleEvents();
            // _private.addMainContentExpansion('xs');
            // this.addShrinkClassOnScroll();
            this.focusing();

        },

        focusing: function() {
            const links = document.querySelectorAll('#nav-main > li > a');

            links.forEach(link => {
                link.addEventListener('focus', () => {
                    link.closest('li').classList.add('focused');
                    if ( window.matchMedia('(max-width: 1209px)').matches ) {
                        link.closest('li').classList.add('active');
                    }
                });

                link.addEventListener('blur', () => {
                    link.closest('li').classList.remove('focused');
                    if ( window.matchMedia('(max-width: 1209px)').matches ) {
                        link.closest('li').classList.remove('active');
                    }
                });
            });

            const links2 = document.querySelectorAll('#nav-main > li > .subnav-list a');

            links2.forEach(link => {
                link.addEventListener('focus', () => {
                    link.closest('#nav-main > li').classList.add('focused');
                    if ( window.matchMedia('(max-width: 1209px)').matches ) {
                        link.closest('#nav-main > li').classList.add('active');
                    }
                });

                link.addEventListener('blur', () => {
                    link.closest('#nav-main > li').classList.remove('focused');
                    if ( window.matchMedia('(max-width: 1209px)').matches ) {
                        link.closest('#nav-main > li').classList.remove('active');
                    }
                });
            });
        },

        removePageOverflowOnDesktop: function(mediaquery) {
            if (mediaquery >= 'lg') {
                $('html').removeClass('menu-active');
                $('.sticky.active').removeClass('active');
                $('#main').removeClass('active');
                $('#main > ul.active').removeClass('active');
                $('#main li.active').removeClass('active');
            }
        },

        addMainContentExpansion: function(mediaquery) {
            if (mediaquery >= 'lg') {
                $('#nav-main > li:not(#nav-login):not(#nav-search)').on({
                    mouseenter : function(e) {
                        const subpages = e.target.querySelectorAll('.subnav-list');
                        if (subpages.length > 0) {
                            $('main').addClass('expanded');
                        }
                    },
                    mouseleave : function(e) {
                        $('main').removeClass('expanded');
                    }
                });
            }
        },

        addMobileHeaderNavEvent: function(mediaquery) {
            if (mediaquery >= 'lg') {
                $('header a.toggle').removeClass('active');
                $('header a.toggle').siblings('ul.header-subnav').removeClass('active');
            }
        },

        addMobileNavToggleEvents: function() {
            $('#nav-main > li:not(#nav-login):not(#nav-search)').on({
                mouseenter : function(e) {
                    const subpages = e.target.querySelectorAll('.subnav-list');
                    if (subpages.length > 0) {
                        $('main').addClass('expanded');
                    }
                },
                mouseleave : function(e) {
                    const subpages = e.target.querySelectorAll('.subnav-list');
                    if (subpages.length > 0) {
                        $('main').removeClass('expanded');
                    }
                }
            });

            $('header').find('a.toggle').on('click', function(e) {
                e.preventDefault();
                $(this).toggleClass('active');
                $(this).siblings('ul.header-subnav').toggleClass('active');
            });

            $('#nav-menu').find('a').on('click', function(e) {
                e.preventDefault();
                // remove active subnavi items
                $(this).closest('ul').find('li.active').removeClass('active');
                // add .active to parent ul
                $('html').toggleClass('menu-active');
                $(this).closest('.sticky').toggleClass('active');
                $(this).closest('#main').toggleClass('active');
                $(this).closest('ul').toggleClass('active');
            });

            $('#nav-search').find('a').on('click', function(e) {
                e.preventDefault();
                // remove active mobile subnavi layer
                $(this).closest('ul').removeClass('active');
                $(this).closest('.sticky').removeClass('active');
                $(this).closest('html').removeClass('active');
                // add .active to li#nav-search
                $('#nav-search').toggleClass('active');
                $('#nav-login').removeClass('active');
            });

            $('#nav-mobile-search').find('a').on('click', function(e) {
                e.preventDefault();
                // remove active mobile subnavi layer
                $(this).closest('#nav-mobile').removeClass('active');
                $(this).closest('.sticky').removeClass('active');
                $(this).closest('html').removeClass('active');

                // add .active to li#nav-search
                $('#nav-mobile-search').toggleClass('active');
                $('#nav-mobile-login').removeClass('active');
            });

            $('#nav-login').find('a:has(span)').on('click', function(e) {
                e.preventDefault();
                // remove active mobile subnavi layer
                $(this).closest('ul').removeClass('active');
                $(this).closest('.sticky').removeClass('active');
                $(this).closest('html').removeClass('active');

                // add .active to li#nav-search
                $('#nav-login').toggleClass('active');
                $('#nav-search').removeClass('active');
            });

            $('#nav-mobile-login').find('a:has(span)').on('click', function(e) {
                e.preventDefault();
                // remove active mobile subnavi layer
                $(this).closest('#nav-mobile').removeClass('active');
                $(this).closest('.sticky').removeClass('active');
                $(this).closest('html').removeClass('active');

                // add .active to li#nav-search
                $('#nav-mobile-login').toggleClass('active');
                $('#nav-mobile-search').removeClass('active');
            });

            var toggle = function(e) {
                e.preventDefault();

                if($(this).closest('li').hasClass('active')) {
                    $(this).closest('li').toggleClass('active');
                    return;
                }

                // remove active subnavi items
                $(this).closest('ul').find('li.active').removeClass('active');
                // add .active to parent li
                $(this).closest('li').toggleClass('active');
            }
            $('nav#main > ul > li:not(#nav-menu) > a.toggle').on('touchstart', toggle);
            $('nav#main > ul > li:not(#nav-menu) > a.toggle').on('click', toggle);
        },

        addShrinkClassOnScroll: function () {
            window.addEventListener('scroll', function(event) {
                if($('.sticky').length) {
                    if(window.pageYOffset > 0) {
                        $('.sticky').addClass('shrink');
                        $('.header-placeholder').addClass('shrink');
                    }
                    else {
                        $('.sticky').removeClass('shrink');
                        $('.header-placeholder').removeClass('shrink');
                    } 
                }
            });

            if($('.sticky').length) {
                if(window.pageYOffset > 0) {
                    $('.sticky').addClass('shrink');
                    $('.header-placeholder').addClass('shrink');
                }
                else {
                    $('.sticky').removeClass('shrink');
                    $('.header-placeholder').removeClass('shrink');
                } 
            }
        }
    }

    // CALL INIT
    $(document).ready(function() {
        _private.init();
    });

    // PUBLIC FUNCTIONS
    return {
        processFlyout: function(flyout) {
            return null;
        }
    }

}(jQuery));
